import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ModalBody, Form, FormGroup } from 'reactstrap';
import TemplateItem from '@shoflo/polymer/components/TemplateChooser/TemplateItem';
import { Button } from '@shoflo/polymer/components/Button/Button';
import { selectLastMediaSource } from '@shoflo/studio-redux/selectors/broadcastSourcesSelector';
import takeBackgroundLive from 'actions/templates/takeBackgroundLive';
import { BACKGROUND_CHOOSER } from 'constants/Modal';
import useModal from 'hooks/useModal';
import {
  StyledCloseButton,
  StyledModalHeader,
  StyledJustifyRight,
  StyledWrapper,
  StyledModal
} from './BackgroundChooser.styled';
import BackgroundUploadForm from 'components/BackgroundUploadForm';

function BackgroundChooser() {
  const dispatch = useDispatch();

  const [templateName, setTemplateName] = useState('');
  const { isOpen, clear } = useModal(BACKGROUND_CHOOSER);
  const isAddButtonDisabled = !templateName;
  const { order: lastMediaOrder = 0 } = useSelector(selectLastMediaSource);
  const { templates: templateMedia, isLoading } = useSelector(
    ({ templates }) => templates
  );

  function handleChange(e) {
    const { value } = e.target;
    setTemplateName(value);
  }

  function handleAdd(e) {
    e.preventDefault();
    const selectedTemplate = templateMedia.find(
      template => template.key === templateName
    );

    onSelectTemplate({
      ...selectedTemplate,
      isEventTemplate: false,
      media: null
    });
  }

  function onSelectTemplate(template) {
    const payload = {
      _id: template._id,
      title: template.name || template.key,
      order: lastMediaOrder + 1,
      value: { eventDocId: template._id, url: template.url }
    };

    dispatch(
      takeBackgroundLive({
        ...payload,
        type: 'backgrounds',
        value: template.value,
        isEventTemplate: template.isEventTemplate
      })
    );

    clear();
    setTemplateName('');
  }

  if (!isOpen) return null;

  const wrapperId = '"media-template-chooser--container';
  const containerElementSelector = `#${wrapperId}`;

  return (
    <StyledModal
      size="xl"
      isOpen={isOpen}
      toggle={clear}
      data-testid="media-template-chooser-modal"
    >
      <StyledModalHeader>
        <div className="top">
          <h5>Choose a background image</h5>
        </div>
        <p>Select a background image, or you can upload your own.</p>
      </StyledModalHeader>
      <ModalBody>
        <BackgroundUploadForm callback={clear} />
        <StyledWrapper id={wrapperId}>
          {!isLoading
            ? templateMedia.map((item, index) => (
                <TemplateItem
                  item={item}
                  index={index}
                  key={index}
                  title={item.title}
                  handleChange={handleChange}
                  containerElementSelector={containerElementSelector}
                />
              ))
            : null}
        </StyledWrapper>

        <Form data-testid="templateChooserForm" onSubmit={handleAdd}>
          <FormGroup>
            <div className="float-end" style={{ display: 'flex' }}>
              <Button
                data-testid="chooseTemplate"
                disabled={isAddButtonDisabled}
                data-dd-action-name="Save Background"
              >
                Save
              </Button>

              <StyledJustifyRight>
                <StyledCloseButton
                  data-testid="closeButton"
                  data-dd-action-name="Close upload background modal"
                  color="light"
                  variant="outlined"
                  onClick={e => {
                    e.preventDefault();
                    clear();
                    setTemplateName('');
                  }}
                >
                  Close
                </StyledCloseButton>
              </StyledJustifyRight>
            </div>
          </FormGroup>
        </Form>
      </ModalBody>
    </StyledModal>
  );
}

export default BackgroundChooser;
